import { render } from "./App.vue?vue&type=template&id=36ae4fab"
const script = {}

import "./App.vue?vue&type=style&index=0&id=36ae4fab&lang=less"
script.render = render

export default script